import { CssBaseline, Grid } from '@mui/material'
import Copyright from 'components/Copyright'
import React from 'react'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router'
import { PublicTemplateStoreStates } from '.'
import Header from './Header'
import { AppContainer, Button, Container, Link, LinkContainer, LinksGrid, Main } from './styles'

type PublicTemplateProps = React.PropsWithChildren<PublicTemplateStoreStates> & {
  showLinks?: boolean
}

const PublicTemplate = (props: PublicTemplateProps) => {
  const { children, auth, showLinks } = props
  const { user } = auth
  const isLoggedIn = user !== null
  const navigate = useNavigate()
  const location = useLocation()
  const isTop = location.pathname === '/'

  return (
    <Container>
      <CssBaseline />
      <AppContainer>
        <Header isLoggedIn={isLoggedIn} />
        <Main>{children}</Main>
        <footer style={{ padding: '8px' }}>
          <Grid
            container
            direction="column"
            sx={{
              alignItems: 'center',
            }}>
            {!isTop && (
              <Grid>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate(isLoggedIn ? '/notifications' : '/login')}>
                  {isLoggedIn ? 'ホームへ' : '使ってみる'}
                </Button>
              </Grid>
            )}
            {showLinks && (
              <LinksGrid container spacing={2}>
                <LinkContainer size={{ sm: 'grow', xs: 12 }}>
                  <Link variant="subtitle1" component={RouterLink} to="/">
                    TOP
                  </Link>
                </LinkContainer>
                <LinkContainer size={{ sm: 'grow', xs: 12 }}>
                  <Link variant="subtitle1" component={RouterLink} to="/terms">
                    利用規約
                  </Link>
                </LinkContainer>
                <LinkContainer size={{ sm: 'grow', xs: 12 }}>
                  <Link variant="subtitle1" component={RouterLink} to="/privacy_policy">
                    プライバシーポリシー
                  </Link>
                </LinkContainer>
              </LinksGrid>
            )}
            <Grid>
              <Copyright />
            </Grid>
          </Grid>
        </footer>
      </AppContainer>
    </Container>
  )
}

export default PublicTemplate
